import packageJson from '../../package.json';

export const repoUrl = new URL(`https://github.com/${packageJson.repository}`);

export const gitCommitHash = process.env.REACT_APP_GIT_COMMIT_HASH;
export const gitCommitDate = process.env.REACT_APP_GIT_COMMIT_DATE;
export const appVersion = gitCommitHash?.slice(0, 7) ?? packageJson.version;
